import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/performance/banner.png'
import _imports_1 from '../../assets/performance/banner4.png'
import _imports_2 from '../../assets/performance/footer.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-589414dc")

_pushScopeId("data-v-589414dc")
const _hoisted_1 = {
  class: "Ecard",
  id: "trendChart"
}
const _hoisted_2 = { class: "testMain" }
const _hoisted_3 = { class: "fitter_title" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, " 删除 ", -1)
const _hoisted_5 = { class: "dialog-footer" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_8 = {
  class: "versionGeneration versionGeneration2",
  style: {}
}
const _hoisted_9 = { id: "perf_report" }
const _hoisted_10 = {
  key: 0,
  class: "spacName"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  class: "banner",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_12 = {
  key: 1,
  class: "spacName"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  class: "banner",
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_14 = { class: "mainContent" }
const _hoisted_15 = {
  key: 0,
  class: "spacName"
}
const _hoisted_16 = { class: "gameTable" }
const _hoisted_17 = {
  rowspan: 3,
  class: "gameIcon"
}
const _hoisted_18 = {
  colspan: 3,
  class: "game_name"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 测试版本: ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 报告创建时间: ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 创建者: ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 场景: ")
const _hoisted_23 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createTextVNode(" 测试类型: "),
  /*#__PURE__*/_createVNode("span", null, "预实例化资源统计")
], -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 测试平台: ")
const _hoisted_25 = { class: "corePerformance spacName" }
const _hoisted_26 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("预实例化资源统计")
], -1)
const _hoisted_27 = {
  key: 0,
  class: "gameTable3"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_empty = _resolveComponent("el-empty")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode("div", _hoisted_3, [
                    _createVNode(_component_el_form, {
                      inline: true,
                      size: "mini",
                      class: "spacForm queryReport"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { label: "报告名称" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.name_search,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.name_search = $event)),
                              placeholder: "请选择",
                              onChange: _ctx.change_name_search
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.nameList, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id_test,
                                    label: item.name + '-[' + item.timestamp + ']',
                                    value: item.id_test
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_popconfirm, {
                              onConfirm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleDelete())),
                              title: "确认删除该报告？",
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  size: "mini",
                                  type: "info",
                                  disabled: _ctx.get_is_super
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_4
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_dialog, {
                              modelValue: _ctx.dialogFormVisible1,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialogFormVisible1 = $event))
                            }, {
                              footer: _withId(() => [
                                _createVNode("span", _hoisted_5, [
                                  _createVNode(_component_el_button, {
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogFormVisible1 = false))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_6
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: _ctx.dialogFormVisible2
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_7
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ])
                              ]),
                              default: _withId(() => [
                                _withDirectives(_createVNode(_component_el_form, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_form_item, {
                                      class: "reportName",
                                      label: "报告名称",
                                      "label-width": _ctx.formLabelWidth
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_input, {
                                          class: "report-input",
                                          modelValue: _ctx.form1.name,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form1.name = $event)),
                                          autocomplete: "off",
                                          width: "500"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }, 8, ["label-width"])
                                  ]),
                                  _: 1
                                }, 512), [
                                  [_vShow, _ctx.dialogFormVisible1]
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode("div", _hoisted_8, [
                    _withDirectives(_createVNode("p", null, [
                      _createVNode("b", null, _toDisplayString("版本号: " +
                    (_ctx.get_core_data.base_info?.version == undefined
                      ? "--"
                      : _ctx.get_core_data.base_info.version) +
                    " - " +
                    "时间: " +
                    (_ctx.get_core_data.base_info?.time == undefined
                      ? "--"
                      : _ctx.get_core_data.base_info.time)), 1)
                    ], 512), [
                      [_directive_loading, _ctx.loading]
                    ])
                  ]),
                  _createVNode("div", _hoisted_9, [
                    (
                  _ctx.localProject !== 34 &&
                  _ctx.localProject !== 40 &&
                  _ctx.localProject !== 47
                )
                      ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_10, [
                          _hoisted_11
                        ], 512)), [
                          [_directive_loading, _ctx.loading]
                        ])
                      : _createCommentVNode("", true),
                    (
                  _ctx.localProject === 34 ||
                  _ctx.localProject === 40 ||
                  _ctx.localProject === 47
                )
                      ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_12, [
                          _hoisted_13
                        ], 512)), [
                          [_directive_loading, _ctx.loading]
                        ])
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_14, [
                      (JSON.stringify(_ctx.get_core_data.base_info) != '{}')
                        ? (_openBlock(), _createBlock("div", _hoisted_15, [
                            _withDirectives(_createVNode("table", _hoisted_16, [
                              _createVNode("tr", null, [
                                _createVNode("td", _hoisted_17, [
                                  _createVNode("img", {
                                    src: _ctx.get_core_data.base_info.project_image
                                  }, null, 8, ["src"])
                                ]),
                                _createVNode("td", _hoisted_18, " 【" + _toDisplayString(_ctx.get_core_data.base_info.project_name) + "】 ", 1)
                              ]),
                              _createVNode("tr", null, [
                                _createVNode("td", null, [
                                  _hoisted_19,
                                  _createVNode("span", null, _toDisplayString(_ctx.get_core_data.base_info.version), 1)
                                ]),
                                _createVNode("td", null, [
                                  _hoisted_20,
                                  _createVNode("span", null, _toDisplayString(_ctx.get_core_data.base_info.time), 1)
                                ]),
                                _createVNode("td", null, [
                                  _hoisted_21,
                                  _createVNode("span", null, _toDisplayString(_ctx.get_core_data.base_info.user), 1)
                                ])
                              ]),
                              _createVNode("tr", null, [
                                _createVNode("td", null, [
                                  _hoisted_22,
                                  _createVNode("span", null, _toDisplayString(_ctx.get_core_data.base_info.scene), 1)
                                ]),
                                _hoisted_23,
                                _createVNode("td", null, [
                                  _hoisted_24,
                                  _createVNode("span", null, _toDisplayString(_ctx.get_core_data.base_info.sys), 1)
                                ])
                              ])
                            ], 512), [
                              [_directive_loading, _ctx.loading]
                            ])
                          ]))
                        : (_openBlock(), _createBlock(_component_el_empty, {
                            key: 1,
                            description: "无数据"
                          })),
                      _withDirectives(_createVNode("div", _hoisted_25, [
                        _hoisted_26,
                        (_ctx.get_core_data.resource_list.length > 0)
                          ? (_openBlock(), _createBlock("table", _hoisted_27, [
                              _createVNode("thead", null, [
                                _createVNode("tr", null, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.theadList, (item) => {
                                    return (_openBlock(), _createBlock("td", { key: item }, _toDisplayString(item), 1))
                                  }), 128))
                                ])
                              ]),
                              _createVNode("tbody", null, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_core_data.resource_list, (item, index) => {
                                  return (_openBlock(), _createBlock("tr", { key: index }, [
                                    _createVNode("td", null, _toDisplayString((index += 1)), 1),
                                    _createVNode("td", null, _toDisplayString(item.uid), 1),
                                    _createVNode("td", null, _toDisplayString(item.count), 1),
                                    _createVNode("td", null, _toDisplayString(item.resource_file), 1)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : (_openBlock(), _createBlock(_component_el_empty, {
                              key: 1,
                              description: "无数据"
                            }))
                      ], 512), [
                        [_directive_loading, _ctx.loading]
                      ])
                    ])
                  ])
                ]),
                _hoisted_28
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})